import equalCarouselSlideHeights from './blog-post-carousel';
export default equalCarouselSlideHeights;
